// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDLcQLwG70nda_e27jRMj4dq4IL3FgQJOU",
  authDomain: "dormee-9d567.firebaseapp.com",
  projectId: "dormee-9d567",
  storageBucket: "dormee-9d567.appspot.com",
  messagingSenderId: "380295375443",
  appId: "1:380295375443:web:146e0748651b56e55634a6",
  measurementId: "G-GXEH8S3HEM",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore and Auth
export const db = getFirestore(app);
export const auth = getAuth(app);
